<template>
  <div>
    <el-dialog title="回复游客" :visible="showReply" @close="close" width='550px'
    :destroy-on-close="true"
    :close-on-click-modal='false'>
      <el-form :model="formData" ref="form" :rules="rules">
        <el-form-item prop="recoveryContent">
          <el-input required v-model="formData.recoveryContent" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" placeholder="请输入回复内容" maxlength="100" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="tips mt20" @click="chooseTip">
        选择快捷回复：尊敬的游客，您反馈的问题我们将尽快优化，感谢您的建议与支持。
      </div>
      <i class="el-icon-warning mt20">
        <span>提交后回复内容讲发送消息至游客小程序中</span>
      </i>
      <div class="btns mt20">
        <el-button type="primary" @click="onSubmit">提交</el-button>
        <el-button type="form" @click="onCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ReplyDialog',
  props: {
    showReply: {
      type: Boolean,
      default: false
    },
    feedbackId: {
      type: String
    }
  },
  data () {
    return {
      formData: {
        recoveryContent: ''
      },
      rules: {
        recoveryContent: [
          { required: true, message: '请输入回复内容', trigger: ['blur', 'trigger'] }
        ]
      }
    }
  },
  methods: {
    close () {
      this.$emit('update:showReply', false)
    },
    chooseTip () {
      const content = this.formData.recoveryContent + '尊敬的游客，您反馈的问题我们将尽快优化，感谢您的建议与支持。'
      if (this.formData.recoveryContent.length <= 100) {
        this.formData.recoveryContent = content.substring(0, 100)
      }
    },
    onSubmit () {
      this.$refs.form.validate().then(() => {
        // console.log('表单', this.formData)
        this.$axios.post(this.$apis.tourist.updateAppUserFeedback, {
          feedbackId: this.feedbackId,
          ...this.formData
        }).then(res => {
          // console.log('回复成功')
          this.close()
          this.$emit('reLoad')
        })
      })
    },
    onCancel () {
      this.formData.recoveryContent = ''
      this.close()
    }
  }
}
</script>

<style scoped lang="scss">
.tips {
  cursor: pointer;
  user-select: none;
  border: 1px solid #bebebe;
  border-radius: 5px;
  background: #f1f3f4;
}
.el-icon-warning {
  span {
    margin-left: 5px;
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-size: 14px;
  }
}
.btns {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
